import React, { Component, Fragment } from 'react';
import { socketConnect } from 'socket.io-react';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import LogoImage from 'assets/megafit-images/mf-logo.svg';
import bannerSignin from 'assets/megafit-images/sign-banner.png';
import DietPlanIcon from 'assets/megafit-images/diat-plan.gif';
import MasterIcon from 'assets/mastercard.svg';
import VisaIcon from 'assets/visa.svg';
import LogoImageIcon from 'assets/megafit-images/mf-logo.svg';

class Confirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      xyz: false
    };
  }

  listener = ({ type, status, data }) => {
    if (status === 'ok') {
      switch (type) {
        case 'email':
          this.setState(data);
          break;
      }
    } else if (status === 'err') {
      this.setState(data);
    }
  };

  componentWillMount() {
    this.props.socket.on('confirmation', this.listener);
  }

  componentWillUnmount() {
    this.props.socket.removeListener('confirmation', this.listener);
  }

  componentDidMount() {
    const { socket, params } = this.props;
    const { type, token } = params || {};
    if (type && token) {
      socket.emit('confirmation', { type, data: { token } });
    } else {
      this.setState({ message: 'This link is not valid' });
    }
    setTimeout(() => this.setState({ xyz: true }), 10);
  }

  render() {
    const { message, xyz } = this.state;
    return (
      <div className={`${xyz ? 'xyz-fin' : 'xyz'}`}>
        <div className='mf-container email-confirm-page'>
          <div class='full-width'>
            <div className='sign-container'>
              <div className='sign-left'>
                <img src={bannerSignin} alt='Megafit-Banner' />
                <div className='sign-left-inner '>
                  <div class="flex-container">
                      <div class="sign-content-left">
                          <h1> 
                              <span class="mainSpan"><span class="small-txt">Customize</span><span class="normal-txt"> Your Fuel,</span></span>
                              <span class="mainSpan"><span class="small-txt">Maximize</span><span class="normal-txt"> Your Gains</span></span>
                          </h1>
                      </div>
                      <div class="sign-content-right">
                          <p>Make you own Macro <br/>Counted Meals with</p>
                          <span class="yellow-box"><strong>MegaFit</strong> CustomFit<sup>®</sup></span>
                      </div>    
                  </div>
                </div> 
              </div>
              <div className={`sign-right`}>
                <div class="sigin-holder">
                  <div class="logo-holder">
                    <div className='logo'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImage} alt='Megafit' /></Link></div>
                    <div className='logo-icon'>  <Link to='/' onClick={() => stop()} onlyActiveOnIndex><img src={LogoImageIcon} alt='Megafit' /></Link></div>   
                  </div>
                  <div className='sign-up-form'>
                    <div className='b-rounded-blue sign-up-form text-center shadowed restore-form'>
                      {message && <span className='colorTitle letter-sm mt-3'>{message}</span>}
                    </div>
                  </div>
                </div>                                
              </div>
            </div>
          </div>
        </div>        
      </div>
    );
  }
}

Confirm.propTypes = {
  socket: PropTypes.object.isRequired,
  params: PropTypes.any.isRequired
};

export default socketConnect(Confirm);
